import FormTrashPage from '@/views/covers/FormTrashPage'

export default function FormTrashScreen() {
  return <FormTrashPage />
}
